import React from "react"
import Link from "gatsby-link"
import StoreLinks from "../components/storeLinks"

const GuidePage = () => (
  <div className="main-container">
    <p>
      Code Sculpture allows you to create 3D art from simple rules. Here are a
      few little video lessons.
    </p>

    <p>
      In Code Sculpture you create more complete shapes by adding new shapes to
      the sides of existing shapes. You do this by applying rules.
    </p>

    <p>
      When you open a rule you will see a "then sculpt faces with" section. Here
      you can choose what shapes to apply to your existing shape. The default in
      None. But you can also apply a new rule to All faces of the shape or
      specific rules to specific faces.
    </p>

    <iframe
      width="320"
      height="180"
      style={{ margin: "auto", display: "block", padding: 20 }}
      src="https://www.youtube.com/embed/zmbyhmSmsdU"
      frameborder="0"
      gesture="media"
      allowfullscreen
    />

    <p>
      In Code Sculpture has two starting shapes a cube and a triangular pyramid
      (or tetrahedron). These have 6 or 4 sides respectively.
    </p>

    <p>New rules can be of 3 kinds:</p>

    <ul>
      <li>
        Pop: which pops outwards from that face (so if applied to the face of a
        cube will add a new cube)
      </li>
      <li>Pyramid: will add a pyramid with a base on the original face</li>
      <li>Truncated Pyramid: a pyramid with a flattened off top</li>
    </ul>

    <p>
      This may seem a bit abstract (unless you are used to mathematical
      descriptions) but play around with different shapes and combinations to
      see what they all look like.
    </p>

    <iframe
      width="320"
      height="180"
      style={{ margin: "auto", display: "block", padding: 20 }}
      src="https://www.youtube.com/embed/gIvwsejHmLg"
      frameborder="0"
      gesture="media"
      allowfullscreen
    />

    <p>
      In Code Sculpture you can change the size of each new shape you add. This
      is done relative to the current shape, so for example a scale of 2 means
      that the new shape will be double the original's size.
    </p>

    <p>A scale of 0.5 (or a half) is half the original shape's size.</p>

    <iframe
      width="320"
      height="180"
      style={{ margin: "auto", display: "block", padding: 20 }}
      src="https://www.youtube.com/embed/oajkTMs8lEs"
      frameborder="0"
      gesture="media"
      allowfullscreen
    />

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/code-sculpture/id1286544769" />
  </div>
)

export default GuidePage



// WEBPACK FOOTER //
// ./src/pages/lessons.js